import { useContext, useEffect, useState } from "react";
import client from "../utils/client";
import { authHeaders } from "../utils/authHeaders";
import { AuthContext } from "../context/authContext";

export default function useUser() {
  const [realTimeUser, setRealTimeUser] = useState(null);

  const { user, token } = useContext(AuthContext);

  function getUserDetails() {
    client({
      url: `/auth/echo?email=${user.email}`,
      method: "GET",
      headers: authHeaders(),
    })
      .then((res) => {
        setRealTimeUser(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    realTimeUser,
  };
}
